import { Box } from '@chakra-ui/react';
import './App.css';
import AllRoutes from './Pages/AllRoutes';


function App() {
  return (
    <Box className="App">
      <AllRoutes/>
    </Box>
  );
}

export default App;
